var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"64df8cfc5c47bbb4f46fa1e07d15d4fadb38c04e"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["marketplace@fieldfolio"]={id:"64df8cfc5c47bbb4f46fa1e07d15d4fadb38c04e"};
      